import { useCallback, useState } from 'react';

export const useDashboardReportPrint = () => {
    const [printModalOpen, setPrintModalOpen] = useState(false);

    const openPrintModal = useCallback(() => {
        setPrintModalOpen(true);
    }, []);

    const closePrintModal = useCallback(() => {
        setPrintModalOpen(false);
    }, []);

    return {
        printModalOpen,
        openPrintModal,
        closePrintModal,
    };
};
